import { render, staticRenderFns } from "./FunctionalData.vue?vue&type=template&id=6b140432&scoped=true"
import script from "./FunctionalData.vue?vue&type=script&lang=js"
export * from "./FunctionalData.vue?vue&type=script&lang=js"
import style0 from "./FunctionalData.vue?vue&type=style&index=0&id=6b140432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b140432",
  null
  
)

export default component.exports